namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1502Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DocMonth: Serenity.LookupEditor;
        DocYear: Serenity.DateYearEditor;
        DocMonthEnd: Serenity.LookupEditor;
        DocYearEnd: Serenity.DateYearEditor;
        SubCat1Code: Serenity.LookupEditor;
    }

    export class QRywcSpec1502Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1502';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1502Form.init)  {
                QRywcSpec1502Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateYearEditor;

                Q.initFormType(QRywcSpec1502Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DocMonth', w0,
                    'DocYear', w3,
                    'DocMonthEnd', w0,
                    'DocYearEnd', w3,
                    'SubCat1Code', w0
                ]);
            }
        }
    }
}
